//import { NgxLoggerLevel } from 'ngx-logger';

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiUrl: 'https://printec-dev-api.reflex360.cl',
  //apiUrl: 'http://localhost:3001',
  //apiUrl: 'https://printec-api.reflex360.cl',
  //apiUrl: 'http://186.104.36.181:3001',
  //apiUrl: 'http://gusvargas.duckdns.org:30000',
  //apiUrl: 'http://10.77.55.2:3000',
  //logLevel: NgxLoggerLevel.TRACE,
  //serverLogLevel: NgxLoggerLevel.OFF,
  ga: 'G-QE0VHC3234-DEV',
};
